import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_VRF_INDOOR',
  GET: 'GET_VRF_INDOOR',
  CREATE: 'CREATE_VRF_INDOOR',
  EDIT: 'EDIT_VRF_INDOOR',
  DELETE: 'DELETE_VRF_INDOOR',
  DUPLICATE: 'DUPLICATE_VRF_INDOOR',
  CLEAR_ERROR: 'CLEAR_ERROR_VRF_INDOOR',
};

export const clearErrorVRFIndoor = () => ({ type: ACTION.CLEAR_ERROR });

const searchVRFIndoor = (pageSize, page, sorted, filtered, isPublic, excludeZoneId = null) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_VRF_INDOOR,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted ? sorted.map(sort => (sort.desc ? `-${sort.id}` : sort.id)).join(',') : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const searchVRFIndoorByText = (text, page = 0, excludeZoneId = null) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  return searchVRFIndoor(pageSize, page, withDefaultSort([]), text, null, excludeZoneId);
};

export const listVRFIndoor = (pageSize, page, sorted, filtered, isPublic) => ({
  type: ACTION.LIST,
  payload: searchVRFIndoor(pageSize, page, sorted, filtered, isPublic)
    .catch(err => Promise.reject(err.response.data)),
});

export const getVRFIndoor = id => ({
  type: ACTION.GET,
  payload: RestClient.request({
    method: 'get',
    url: `${Constants.API_VRF_INDOOR}${id}/`,
  }).catch(err => Promise.reject(err.response.data)),
});

const buildFormData = ({ name, code, indoorForm, coolingCap, unitId, fanPower, description, image, cfp_value: cfpValue, cfp_unit: cfpUnit }, partial) => {
  const fd = new FormData();
  const set = (key, val, always) => {
    if (always || val || val === 0) fd.set(key, val);
  };
  set('name', name, !partial);
  if (code !== undefined) fd.set('code', code);
  set('indoor_form', indoorForm, !partial);
  set('cooling_capacity', coolingCap, !partial);
  set('unit', unitId, !partial);
  set('fan_power_input', fanPower, !partial);
  if (typeof description === 'string') fd.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') fd.set('cfp_value', cfpValue);
  if (cfpUnit) fd.set('cfp_unit', cfpUnit);
  if (image) fd.set('image', image, `vrfin_${new Date().valueOf()}`);
  return fd;
};

export const createVRFIndoor = params => ({
  type: ACTION.CREATE,
  payload: RestClient.request({
    method: 'post',
    url: Constants.API_VRF_INDOOR,
    data: buildFormData(params, false),
  }).catch(err => Promise.reject(err.response.data)),
});

export const editVRFIndoor = (id, params) => ({
  type: ACTION.EDIT,
  payload: RestClient.request({
    method: 'patch',
    url: `${Constants.API_VRF_INDOOR}${id}/`,
    data: buildFormData(params, true),
  }).catch(err => Promise.reject(err.response.data)),
});

export const deleteVRFIndoor = id => ({
  type: ACTION.DELETE,
  payload: RestClient.request({
    method: 'delete',
    url: `${Constants.API_VRF_INDOOR}${id}/`,
  })
    .then(() => ({ id }))
    .catch(err => Promise.reject(err.response.data)),
});

export const duplicateVRFIndoor = (id, name) => ({
  type: ACTION.DUPLICATE,
  payload: RestClient.request({
    method: 'post',
    url: `${Constants.API_VRF_INDOOR}${id}/copy/`,
    data: { new_name: name },
  }).catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/vrf/vrf_indoor_actions.js